/**
 * Internal dependencies.
 */
import edit from './edit';
import save from './save';
import metadata from './block.json';
import { EditorKitchensink as icon } from '../../components/Icons';
import styles from './inline-styles';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes, supports } = metadata;

const settings = {
	title: __( 'Content Toggle Item' ),
	description: __( 'Gutenify Content Toggle item.' ),
	icon: <Icon icon={ icon } />,
	parent: [ 'gutenify/content-toggle-item' ],
	keywords: [
		'gutenify',
		__( 'Content Toggle item' ),
		__( 'Content Toggle' ),
	],
	example: {
		attributes: {
		},
	},
	attributes,
	edit,
	save,
	supports,
	gutenify: {
		customStylesCallback( props ) {
			return styles( props );
		},
	},
};

export { name, category, settings };
